import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';

import { type Surface } from '../../common/types';

export const setModuleStateAtPath =
	(modulePath: string) =>
	<NewProps = {}>(
		surface: Surface,
		newProps:
			| NewProps
			| null
			| {
					componentName: string;
					props: NewProps;
			  },
	) => {
		const surfaceCopy = cloneDeep(surface);

		switch (true) {
			case newProps === null:
				set(surfaceCopy, modulePath, null);
				break;
			case (newProps as Object).hasOwnProperty('componentName') &&
				(newProps as Object).hasOwnProperty('props'):
				set(surfaceCopy, `${modulePath}.name`, (newProps as any).componentName);
				set(surfaceCopy, `${modulePath}.fields`, (newProps as any).props);
				break;
			default:
				set(surfaceCopy, `${modulePath}.fields`, newProps);
				break;
		}

		return surfaceCopy;
	};
